import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "features/store";

type ResetPasswordRouteProps = {
  children: JSX.Element;
};

const ResetPasswordRoute = ({ children }: ResetPasswordRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isAuthenticated && user && user.is_pass_reset) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ResetPasswordRoute;
